import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Garden-Review: UK Gardening Guides, Reviews & Tips" },
      { name: "description", content: "UK gardening guides, hands-on product reviews and seasonal plant care tips to help your garden thrive. Explore buying guides, how-tos and tool reviews." },
      { property: "og:title", content: "Garden-Review: UK Gardening Guides, Reviews & Tips" },
      { property: "og:description", content: "UK gardening guides, hands-on product reviews and seasonal plant care tips to help your garden thrive. Explore buying guides, how-tos and tool reviews." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.garden-review.co.uk/" }],
  }),
  component: Index,
});
